module.exports = __webpack_public_path__ + "static/introMotion-3e3923f9c17073a071a4d9151445c6d7.mp4";